import { Extension } from '@tiptap/core';

const PopupExtension = Extension.create({
  name: 'popupExtension',

  RawCommands() {
    return {
      setPopupContent: (content: string) => () => true,
    };
  },
});

export default PopupExtension;
